const MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
export const periodLabel = (p) => (p && p.length >= 7 ? `${MONTHS[Number(p.slice(5, 7)) - 1] || p} ${p.slice(0, 4)}` : p || "—");

const tr = (a, b) => a.localeCompare(b, "tr");

// Kayıtlar Dönem + Proje + Bölge + Ana Hizmet bazında gruplanır; grup içi kayıtlar hizmet adı → tarih sırasında.
// Düzeltme farkları genel bir satıra değil, ait olduğu proje / bölge / ana hizmet grubuna (ve hizmet ara toplamına) ± olarak yazılır.
export function groupRows(rows, totalKey, corrections = []) {
  const map = new Map();
  const add = (r, isCorrection) => {
    const period = (r.entry_date || "").slice(0, 7);
    const g = { period, project_id: r.project_id || "", project_name: r.project_name || "—", region_name: r.region_name || "Bölge Yok", category_id: r.category_id || "", category_name: r.category_name || "—" };
    const key = [g.period, g.project_name, g.region_name, g.category_name].join("|");
    const cur = map.get(key) || { key, ...g, total: 0, items: [], services: new Set(), correction_total: 0, correction_count: 0 };
    const amt = Number(r[totalKey]) || 0;
    cur.total += amt;
    if (isCorrection) { cur.correction_total += amt; cur.correction_count += 1; }
    cur.items.push(isCorrection ? { ...r, is_correction: true } : r);
    cur.services.add(r.service_name || "—");
    map.set(key, cur);
  };
  for (const r of rows) add(r, false);
  for (const r of corrections) add(r, true);
  for (const g of map.values()) {
    g.items.sort((a, b) => tr(a.service_name || "", b.service_name || "") || (a.is_correction ? 1 : 0) - (b.is_correction ? 1 : 0) || (a.entry_date || "").localeCompare(b.entry_date || ""));
    g.service_count = g.services.size;
    g.service_totals = {};   // hizmet ara toplamı (detayda ilk satırın yanında) — o hizmetin düzeltme farkı dahil
    for (const r of g.items) g.service_totals[r.service_name || "—"] = (g.service_totals[r.service_name || "—"] || 0) + (Number(r[totalKey]) || 0);
  }
  return [...map.values()].sort((a, b) => a.period.localeCompare(b.period) || tr(a.project_name, b.project_name) || tr(a.region_name, b.region_name) || tr(a.category_name, b.category_name));
}
